import { Box } from "@mui/material";
import HeaderAppBar from "./appbar";
// import AddPromotionImages from "./add_promotions_imgs";
import DisplayPromoContent from "./content_below_promo";
import CreateDisplayCards from "./generate_cards";
// import DisplayContentBelowTheCards from "./dis_cont_below_promo";
import { FloatingActionButton } from "./floating_buttons";
import CreateServiceCard from "./service_cards";
import CreateFooterPage from "./footer_page";
import HeroSection from "./hero_section";

function HomePage() {
    return (
        <Box >
            <HeaderAppBar/>
            <HeroSection/>
            <DisplayPromoContent/>
            <CreateDisplayCards/>
            {/* <DisplayContentBelowTheCards/> */}
            <FloatingActionButton/>
            <CreateServiceCard/>
            <CreateFooterPage/>
    </Box>
    )
}

export default HomePage;